import * as yup from 'yup'

export const numberSchema = yup.number().strict().nullable()
